import { DEFAULT_PAGINATION, type DefaultPagination, type FilterWithPaginationStateShape } from 'hooks';
import { useFilterWithPaginationV2, filterWithPaginationStates } from 'hooks/useFilterWithPaginationV2';
import type { MeterModulesApiFilter } from 'lib/services';

export type MeterModulesFilter = Pick<MeterModulesApiFilter, 'search' | 'meterModels' | 'sort' | 'technologies'> & {
  technologies?: MeterModulesApiFilter['technologies'];
};
export type MeterModulesFilterWithPaginationShape = FilterWithPaginationStateShape<MeterModulesFilter>;

const STATE_KEY = 'MeterModulesListFilterState';

export const DEFAULT_FILTER: MeterModulesFilter = {
  search: undefined,
  meterModels: undefined,
  technologies: undefined,
  sort: {
    name: 'asc',
  },
};

export const DEFAULT_METER_MODULES_PAGINATION: DefaultPagination = {
  ...DEFAULT_PAGINATION,
};

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: DEFAULT_METER_MODULES_PAGINATION,
});

export const useModulesListFilterWithPagination = (): MeterModulesFilterWithPaginationShape =>
  useFilterWithPaginationV2(states);
